module.exports = __webpack_public_path__ + "img/v7.4c71bcd4.png";